import { configureStore } from '@reduxjs/toolkit';

import ableReducer from './ableReducer';
import demoReducer from './demoReducer';
import authReducer from '../Pages/Login/LoginSlice';
import commonReducer from './reducers/common';
import subscriptionReducer from './reducers/subscription';
import profileReducer from './reducers/profile';
import invoiceReducer from './reducers/invoice';
import dashboardReducer from './reducers/dashboard';
import paymentReducer from './reducers/payment';
import supportReducer from './reducers/support';
import { localStorageMiddleware } from './middleware';

export function makeStore(preloadedState) {
  return configureStore({
    reducer: {
      auth: authReducer,
      able: ableReducer,
      demo: demoReducer,
      common: commonReducer,
      subscription: subscriptionReducer,
      profile: profileReducer,
      invoice: invoiceReducer,
      dashboard: dashboardReducer,
      payment: paymentReducer,
      support: supportReducer,
    },
    devTools: true,
    preloadedState,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware(),
      localStorageMiddleware,
    ],
  });
}

const store = makeStore();

export default store;
